import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from '../../utils/text';
import DeleteButton from '../DeleteButton';
import TrafoPreview from '../TrafoPreview';
import { ErrorsShape, MediaItemShape } from '../../utils/shapes';
import Input from '../inputs/Input';
import TextArea from '../inputs/TextArea';

const UploadWorkMediaPreview = (props) => (
    <div className="upload-work__media-preview">
        <div className="d-flex flex-wrap">
            <div className="d-flex flex-column mr-5 mb-4">
                <TrafoPreview file={props.file} mediaItem={props.media} size={'medium'} />
                {props.withDelete ? (
                    <div className="ml-auto mr-auto mt-2">
                        <DeleteButton onClick={props.onDelete} />
                    </div>
                ) : null}
            </div>
            <div className="d-flex flex-column flex-grow-1">
                <div className="mb-3 text-bold">{props.file ? props.file.name : props.media.title}</div>
                <Input
                    className="mb-3"
                    name="title"
                    error={props.errors.title}
                    placeholder={gettext('Add title')}
                    value={props.title}
                    onChange={props.handleChange}
                />
                <TextArea
                    className="mb-3"
                    name="comment"
                    rows={3}
                    error={props.errors.comment}
                    placeholder={gettext('Insert work description that will be displayed under the work')}
                    value={props.comment}
                    onChange={props.handleChange}
                />
                <input name="media" value={props.media.id} readOnly hidden />
            </div>
        </div>
    </div>
);

UploadWorkMediaPreview.propTypes = {
    file: PropTypes.instanceOf(File),
    media: MediaItemShape.isRequired,
    title: PropTypes.string.isRequired,
    comment: PropTypes.string.isRequired,
    errors: ErrorsShape,
    withDelete: PropTypes.bool,
    handleChange: PropTypes.func,
    onDelete: PropTypes.func,
};

UploadWorkMediaPreview.defaultProps = {
    file: null,
    errors: {},
    withDelete: true,
    handleChange: undefined,
    onDelete: undefined,
};

export default UploadWorkMediaPreview;



// WEBPACK FOOTER //
// ./src/components/arena/UploadWorkMediaPreview.js